import { tsValidate, tsValidateArray, tsValidateBoolean, tsValidateNumber, tsValidateOptionalId, tsValidateString, tsValidateUniqueId } from '@nu-art/ts-common';
import { AdvisorRuntimeIDBGroup } from '../_core/index.js';
const Validator_SmartNoteSection = (section) => {
    if (!section)
        return 'Did not receive smart note section';
    return tsValidate(section, {
        title: tsValidateString(-1, false),
        content: tsValidateString(-1, false),
        aiContent: tsValidateString(-1, false),
        dbNoteId: tsValidateOptionalId,
        isEditable: tsValidateBoolean(),
        isSelectable: tsValidateBoolean(),
        isSelected: tsValidateBoolean(),
        indent: tsValidateBoolean(false),
        dispositionSection: tsValidateBoolean(false),
        subSections: tsValidateArray(Validator_SmartNoteSection),
    });
};
const Validator_ModifiableProps = (note) => {
    if (!note)
        return 'Did not receive smart note';
    // @ts-ignore - getting rid of python only prop
    delete note.smartDocType;
    // @ts-ignore - getting rid of python only prop
    delete note.timeCreated;
    return tsValidate(note, {
        _id: tsValidateUniqueId,
        __created: tsValidateNumber(),
        __updated: tsValidateNumber(),
        title: tsValidateString(),
        encounterId: tsValidateUniqueId,
        content: tsValidateString(-1, false),
        sections: tsValidateArray(Validator_SmartNoteSection),
        templateId: tsValidateUniqueId,
        savedByPhysician: tsValidateBoolean(),
        aiMode: tsValidateBoolean(false),
        aiText: tsValidateString(),
    });
};
const Validator_GeneratedProps = {};
export const DBDef_RuntimeSmartNote = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'runtime-smart-note',
    entityName: 'runtime-smart-note',
    frontend: {
        group: AdvisorRuntimeIDBGroup,
        name: 'runtime-smart-note'
    },
    backend: {
        name: 'runtime-smart-note'
    }
};
//# sourceMappingURL=db-def.js.map